import { ProjectV2 } from "../data/getProjectsV2"

export enum ProjectStatus {
    Ready = "Ready",
    Analysing = "Analysing",
    WaitingForBusinessQuestion = "WaitingForBusinessQuestion",
}

export function getProjectStatus(events: ProjectV2["events"]) {
    const sources = events.map((e) => e.source)
    if (sources.includes("project.summary.success")) {
        return ProjectStatus.Ready
    } else if (
        sources.includes("project.analysis.success") &&
        !sources.includes("project.additionalContexts.updated")
    ) {
        return ProjectStatus.WaitingForBusinessQuestion
    } else {
        return ProjectStatus.Analysing
    }
}
